"use client";

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import type { LinkProps } from 'next/link';
import type { Route } from 'next';

interface NavLinkProps<T extends string> extends Omit<LinkProps<T>, 'href'> {
  href: Route<T>;
  children: React.ReactNode;
  className?: string;
}

export default function NavLink<T extends string>({ 
  href, 
  children, 
  className = '', 
  ...props 
}: NavLinkProps<T>) {
  const pathname = usePathname();
  const isActive = pathname === href;

  return (
    <Link
      href={href}
      className={`px-3 py-1 my-1 inline-flex items-center transition-all duration-300 relative group ${
        isActive
          ? "text-[#38b5a0] font-semibold"
          : "text-[#1a2942] hover:text-[#38b5a0]"
      } ${className}`}
      {...props}
    >
      {children}
      <span
        className={`absolute bottom-0 left-0 w-full h-0.5 bg-[#38b5a0] transform origin-left transition-transform duration-300 ${
          isActive ? "scale-x-100" : "scale-x-0 group-hover:scale-x-100"
        }`}
      />
    </Link>
  );
}
